import {ErrorBoundary} from 'react-error-boundary';
import React, {Suspense} from 'react';
import SafeDrivingContentsLoadingKr from '@di-shared/features/safe-driving/kr/SafeDrivingContentsLoading.kr';
import SafeDrivingContentsErrorKr from '@di-shared/features/safe-driving/kr/SafeDrivingContentsError.kr';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import Header from '@di-shared/features/common/Header';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import SafeDrivingContentsKr from '@di-shared/features/safe-driving/kr/SafeDrivingContents.kr';
import {useEnvironmentStore} from '@di-shared/features/environment/environmentStore';
import {RegionType} from '@shared/cci/features/const/environment';
import SafeDrivingContentsEu from '@di-shared/features/safe-driving/eu/SafeDrivingContents.eu';

export interface SafeDrivingPageProps {
  vin: string;
}

function SafeDrivingPage({vin}: SafeDrivingPageProps) {
  const {t} = useInferableTranslation();
  const region = useEnvironmentStore((state) => state.region);

  return (
    <div className="wrap">
      <ScrollToTopOnMount />

      {region === RegionType.KR ? (
        <>
          <Header left={<HeaderBackButton />}>
            <h1 className="headline_xxsmall nav_center_title">{t('T40004')}</h1>
          </Header>
          <ErrorBoundary fallback={<SafeDrivingContentsErrorKr />}>
            <Suspense fallback={<SafeDrivingContentsLoadingKr />}>
              <SafeDrivingContentsKr vin={vin} />
            </Suspense>
          </ErrorBoundary>
        </>
      ) : region === RegionType.EU ? (
        <ErrorBoundary fallback={<SafeDrivingContentsEu.Error vin={vin} />}>
          <Suspense fallback={<SafeDrivingContentsEu.Loading />}>
            <SafeDrivingContentsEu vin={vin} />
          </Suspense>
        </ErrorBoundary>
      ) : (
        <></>
      )}
    </div>
  );
}

export default SafeDrivingPage;
